import { Box, FlexLayout, GridLayout, H3, H4 } from '@deity/falcon-ui';
import { Collapsible } from 'components/PropertyListEditor/Collapsible';
import type { FC } from 'react';

interface LinkInfoDefaultProps {
  locked?: boolean;
  fieldPath: Array<string>;
  fieldName: string;
}
const LinkInfo: FC<LinkInfoDefaultProps> = ({ locked = false, fieldPath, fieldName }) => (
  <Box>
    <Collapsible title="Link Settings" itemTitle="PROPERTIES" collapsed={false}>
      <FlexLayout bg="panelLight" mt="xs" mb="xs" borderRadius="small" p="xs">
        <GridLayout gridTemplateColumns="1fr 2fr" borderBottom="regular" p="xs" borderColor="secondary" width="full">
          <H4 fontWeight="bold" color="secondary">
            BEHAVIOR
          </H4>
          <H4 fontWeight="bold" color="secondary" justifySelf="center">
            VALUE
          </H4>
          <H3>Name</H3>
          <Box>{fieldName}</Box>
          <H3>Path</H3>
          <Box>{`${fieldPath.join('.')}`}</Box>
        </GridLayout>
      </FlexLayout>
    </Collapsible>
  </Box>
);
export default LinkInfo;
